// TODO: This needs to be updated whenever we add new INTERFACE types and should be automated in the future
// https://www.apollographql.com/docs/react/advanced/fragments.html#fragment-matcher

const introspectionQueryResultData = {
  __schema: {
    types: [
      {
        kind: 'INTERFACE',
        name: 'PaginatedList',
        possibleTypes: [
          {
            name: 'BillingInvoiceList'
          },
          {
            name: 'NotificationPreferenceList'
          },
          {
            name: 'CollaboratorList'
          },
          {
            name: 'SurveyPageList'
          },
          {
            name: 'SurveyQuestionList'
          },
          {
            name: 'CollectorList'
          },
          {
            name: 'AnalysisStandardViewList'
          },
          {
            name: 'CrossTabReportList'
          },
          {
            name: 'SurveyQuestionRowList'
          },
          {
            name: 'SurveyQuestionOptionList'
          },
          {
            name: 'SurveyQuestionColumnList'
          },
          {
            name: 'SurveyQuestionColumnChoiceList'
          }
        ]
      },
      {
        kind: 'INTERFACE',
        name: 'SurveyQuestion',
        possibleTypes: [
          {
            name: 'SingleChoiceQuestion'
          },
          {
            name: 'MatrixQuestion'
          },
          {
            name: 'OpenEndedQuestion'
          },
          {
            name: 'DemographicQuestion'
          },
          {
            name: 'MultipleChoiceQuestion'
          },
          {
            name: 'DatetimeQuestion'
          },
          {
            name: 'BasicQuestion'
          }
        ]
      },
      {
        kind: 'INTERFACE',
        name: 'AnalysisStandardViewFilterRule',
        possibleTypes: [
          {
            name: 'QuestionAndAnswerFilter'
          },
          {
            name: 'CollectorFilter'
          },
          {
            name: 'TimePeriodFilter'
          },
          {
            name: 'CompletenessFilter'
          },
          {
            name: 'ABFilter'
          },
          {
            name: 'TagFilter'
          }
        ]
      },
      {
        kind: 'INTERFACE',
        name: 'AnalysisStandardViewCompareRule',
        possibleTypes: [
          {
            name: 'QuestionAndAnswerCompare'
          },
          {
            name: 'ABCompare'
          }
        ]
      },
      {
        kind: 'INTERFACE',
        name: 'SurveyQuestionOption',
        possibleTypes: [
          {
            name: 'SurveyQuestionRow'
          },
          {
            name: 'SurveyQuestionOther'
          },
          {
            name: 'SurveyQuestionColumn'
          },
          {
            name: 'SurveyQuestionColumnChoice'
          }
        ]
      },
      {
        kind: 'INTERFACE',
        name: 'QuestionResponseSummary',
        possibleTypes: [
          {
            name: 'OneDimensionalResponseSummary'
          },
          {
            name: 'TwoDimensionalResponseSummary'
          }
        ]
      },
      {
        kind: 'INTERFACE',
        name: 'Project',
        possibleTypes: [
          {
            name: 'ConceptTestingProject'
          }
        ]
      },
      {
        kind: 'INTERFACE',
        name: 'ProjectVariableConfiguration',
        possibleTypes: [
          {
            name: 'DefaultConfiguration'
          },
          {
            name: 'ImageStimuliVariableConfiguration'
          },
          {
            name: 'AttributesVariableConfiguration'
          }
        ]
      },
      {
        kind: 'INTERFACE',
        name: 'ProjectVariableAnswer',
        possibleTypes: [
          {
            name: 'QuestionVariableAnswer'
          },
          {
            name: 'QuestionBankVariableAnswer'
          },
          {
            name: 'BalueVariableAnswer'
          }
        ]
      },
      {
        kind: 'INTERFACE',
        name: 'QuestionVariableAnswerData',
        possibleTypes: [
          {
            name: 'DefaultQuestionVariableAnswerData'
          },
          {
            name: 'ABQuestionVariableAnswerData'
          }
        ]
      }
    ]
  }
};

module.exports = introspectionQueryResultData;
